// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_YHQ","cls2":"FeedbackModal-cls2__3y FeedbackModal-cls1_YHQ"};